import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import tinymce from 'tinymce/tinymce';
// import 'tinymce/skins/content/default/content.css'
import Editor from '@tinymce/tinymce-vue';
import 'tinymce/themes/silver';
import 'tinymce/themes/silver/theme';
import 'tinymce/icons/default'; //引入编辑器图标icon，不引入则不显示对应图标
import 'tinymce/models/dom'; // 这里是个坑 一定要引入
//在TinyMce.vue中接着引入相关插件
import 'tinymce/icons/default/icons';
import 'tinymce/plugins/image'; // 插入上传图片插件
import 'tinymce/plugins/media'; // 插入视频插件
import 'tinymce/plugins/table'; // 插入表格插件
import 'tinymce/plugins/lists'; // 列表插件
import 'tinymce/plugins/wordcount'; // 字数统计插件
// import 'tinymce/plugins/code' // 源码
import 'tinymce/plugins/fullscreen'; //全屏
import 'tinymce/plugins/preview'; //预览
import 'tinymce/plugins/link'; // 链接
import 'tinymce/plugins/codesample'; // 代码
// import 'tinymce/plugins/code' // 代码
//接下来定义编辑器所需要的插件数据
import { reactive, ref } from 'vue';
import { onMounted, watch } from '@vue/runtime-core';
import axios from 'axios';
import { message } from 'ant-design-vue';
// import { updateImg } from '@/api/order/order'
export default /*#__PURE__*/_defineComponent({
  __name: 'TEditor',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: () => {
        return '';
      }
    },
    baseUrl: {
      type: String,
      default: `${process.env.VUE_APP_DOMAIN}/${process.env.VUE_APP_SERVENAME}/fileManager/fileUpload?versionName=v1.0`
    },
    disabled: {
      type: Boolean,
      default: false
    },
    plugins: {
      type: [String, Array],
      default: 'lists  table image media preview link codesample'
    },
    toolbar: {
      type: [String, Array],
      default: `bold italic underline alignleft aligncenter alignright alignjustify
      | undo redo | fontfamily fontsize blocks | forecolor backcolor
      | bullist numlist outdent indent | lists table | removeformat
      | preview | link | codesample`
      // | image code | media code
    } //必填
  },
  emits: ['getContent', 'update:loading'],
  setup(__props, {
    expose,
    emit: emits
  }) {
    const props = __props;
    //JS部分
    //在js中引入所需的主题和组件
    //这里我选择将数据定义在props里面，方便在不同的页面也可以配置出不同的编辑器，当然也可以直接在组件中直接定义
    const editorRef = ref();
    const uploadImageUrlMap = ref({});
    //用于接收外部传递进来的富文本
    const myValue = ref(props.value);
    const tinymceId = ref('vue-tinymce-' + +new Date() + ((Math.random() * 1000).toFixed(0) + ''));
    //定义一个对象 init初始化
    const init = reactive({
      selector: '#' + tinymceId.value,
      language_url: '/tinymce/langs/zh-Hans.js',
      language: 'zh-Hans',
      skin_url: '/tinymce/skins/ui/oxide',
      height: '100%',
      branding: false,
      menubar: 'file edit insert view format table ',
      statusbar: true,
      plugins: props.plugins,
      toolbar: props.toolbar,
      font_family_formats: '等线; Arial=arial,helvetica,sans-serif; 宋体=SimSun; 微软雅黑=Microsoft Yahei; Impact=impact,chicago;',
      font_size_formats: '11px 12px 14px 16px 18px 24px 36px 48px 64px 72px',
      line_height_formats: '1 1.1 1.2 1.3 1.4 1.5 2 3 4',
      // paste_convert_word_fake_lists: false, // 插入word文档需要该属性
      nonbreaking_force_tab: false,
      paste_auto_cleanup_on_paste: false,
      file_picker_types: 'file',
      content_css: '/tinymce/skins/content/default/content.css',
      paste_data_images: true,
      //图片上传
      //   images_upload_handler: (blobInfo: any, progress: any) =>{
      //       // const ph = '/'
      //   //     let params = new FormData()
      //   //     params.append('file', blobInfo.blob())
      //   //     let config = {
      //   //   headers: {
      //   //     'Content-Type': 'multipart/form-data',
      //   //   },
      //   // }
      //   //     axios
      //   //       .post(props.baseUrl, params, config)
      //   //   .then((res) => {
      //   //     console.log(res, 'res')
      //   //   })
      // },
      // 文件上传
      // file_picker_callback: (callback: any, value: any, meta: any) => {
      //   // Provide file and text for the link dialog
      //   if (meta.filetype == 'file') {
      //     callback('mypage.html', { text: 'My text' })
      //   }
      //   // Provide image and alt text for the image dialog
      //   if (meta.filetype == 'image') {
      //     callback('myimage.jpg', { alt: 'My alt text' })
      //   }
      //   // Provide alternative source and posted for the media dialog
      //   if (meta.filetype == 'media') {
      //     callback('movie.mp4', { source2: 'alt.ogg', poster: 'image.jpg' })
      //   }
      // },
      // 粘贴
      paste_preprocess: function (plugin, args) {
        // 获取粘贴的文本内容
        let content = args.content;
        // 添加 target="_blank" 到所有的 a 标签
        args.content = args.content.replace(/(<a\s)/gi, '$&target="_blank" ');
        // 在这里提取文本中的图片 URL
        let imageUrls = extractImageUrlsFromText(content);
        imageUrls.length && emits('update:loading', true);
        // 如果没有图片，则不进行处理
        imageUrls.length && convertUrlsToFiles(imageUrls).then(function (fileList) {
          // 在此处处理转换后的文件对象列表
          let postArr = fileList.map(file => {
            return uploadFile(file);
          });
          Promise.all(postArr).then(res => {
            for (let j = 0; j < imageUrls.length; j++) {
              uploadImageUrlMap.value[imageUrls[j]] = res[j].url;
              // // 将上传后的图片 URL 替换原来的图片 URL
              // content = content.replaceAll(imageUrls[j], res[j].url);
            }
            message.success('图片上传成功');
            emits('update:loading', false);
            // args.content = content;
          });
        }).catch(function () {
          message.success('图片上传失败');
          emits('update:loading', false);
        });
      }
    });
    // 上传文件
    const uploadFile = file => {
      let params = new FormData();
      params.append('file', file);
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      };
      return axios.post(props.baseUrl, params, config);
    };
    // 获取所有的图片路径
    const extractImageUrlsFromText = text => {
      let regex = /<img[^>]+src="([^"]+)"/g;
      let matches = text.match(regex);
      let imageSrcList = [];
      if (matches) {
        for (let i = 0; i < matches.length; i++) {
          let imgSrc = matches[i] ? matches[i].match(/src="([^"]+)"/)[1] : '';
          imageSrcList.push(imgSrc);
        }
      }
      return imageSrcList;
    };
    // 路径转文件
    const urlToFile = (url, fileName, mimeType) => {
      return new Promise((resolve, reject) => {
        let image = new Image();
        image.crossOrigin = 'Anonymous';
        image.onload = function () {
          let canvas = document.createElement('canvas');
          let context = canvas.getContext('2d');
          canvas.width = image.width;
          canvas.height = image.height;
          context.drawImage(image, 0, 0);
          canvas.toBlob(function (blob) {
            if (blob) {
              resolve(new File([blob], fileName, {
                type: mimeType || blob.type
              }));
            } else {
              reject(new Error('Failed to convert image to file'));
            }
          }, mimeType);
        };
        image.onerror = function () {
          reject(new Error('Failed to load image'));
        };
        image.src = url;
      });
    };
    const convertUrlsToFiles = urlList => {
      let promises = urlList.map(function (url, index) {
        let fileName = Date.now() + index + '.png';
        return urlToFile(url, fileName);
      });
      return Promise.all(promises);
    };
    expose({
      uploadImageUrlMap
    });
    //监听外部传递进来的的数据变化
    watch(() => props.value, () => {
      myValue.value = props.value;
      emits('getContent', myValue.value);
    });
    //监听富文本中的数据变化
    watch(() => myValue.value, () => {
      emits('getContent', myValue.value);
    });
    //在onMounted中初始化编辑器
    onMounted(() => {
      tinymce.init({});
      let editor = editorRef.value.getEditor();
      editor.on('ExecCommand', function checkListNodes(evt) {
        var cmd = evt.command;
        var val = evt.value;
        var node = evt.target.selection.getNode();
        var nodeParent = node.parentNode;
        if (cmd === 'FontSize' || cmd === 'FontName') {
          if (node.nodeName === 'STRONG') {
            editor.dom.setStyle(nodeParent.parentNode.parentNode, 'font-size', val);
          } else if (node.nodeName === 'SPAN') {
            editor.dom.setStyle(nodeParent.parentNode, 'font-size', val);
          } else if (node.nodeName === 'UL' || node.nodeName === 'OL') {
            var li = editor.dom.select('li', node);
            if (cmd === 'FontSize') {
              editor.dom.setStyle(li, 'font-size', val);
            }
            if (cmd === 'FontName') {
              editor.dom.setStyle(li, 'font-family', val);
            }
          }
        }
      });
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_unref(Editor), {
        modelValue: myValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => myValue.value = $event),
        init: init,
        disabled: __props.disabled,
        id: tinymceId.value,
        ref_key: "editorRef",
        ref: editorRef
      }, null, 8, ["modelValue", "init", "disabled", "id"]);
    };
  }
});